// Module
var code = "<a class=\"btn subFormControl\"> <i class=\"fa fa-code\"></i> <span>Generic Button</span> </a>";
// Exports
export default code;